import { routes as chat_professor_turma } from './chat_professor_turma'
import { routes as chat_estudante_professor } from './chat_estudante_professor'
import { routes as chat_responsavel_professor } from './chat_responsavel_professor'
import { routes as chat } from './chat'
import { routes as reports } from './reports'
import { routes as saeweb } from './saeweb'
import { routes as grade_horario } from './grade_horario'
import { routes as eventos } from './eventos'
import { routes as drive_arquivos } from './drive_arquivos'
import { routes as notas_versao } from './notas_versao'
import { routes as mensagensbloqueios } from './menssagembloqueio'
import { routes as licitacoes } from './licitacoes'
import { routes as geradorrelatorios } from './geradorrelatorios'
import { routes as atividadesusuario } from './atividadesusuario'

export default [
  {
    path: '/ferramentas',
    name: 'Ferramentas',
    description: 'Ferramentas',
    children: [
      ...chat,
      ...chat_professor_turma,
      ...chat_estudante_professor,
      ...chat_responsavel_professor,
      ...reports,
      ...saeweb,
      ...grade_horario,
      ...eventos,
      ...drive_arquivos,
      ...notas_versao,
      ...mensagensbloqueios,
      ...licitacoes,
      ...geradorrelatorios,
      ...atividadesusuario
    ],
    goesToMenu: true
  }
]
